import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ProfilePicture = ({ learnerName, profilePicUrl, quiz, isMobile }) => {
    const { themeStyles } = useTheme();
    // If no profile picture is provided, use a default avatar
    const defaultAvatar =
        'https://www.w3schools.com/w3images/avatar2.png'; // You can change this URL to any default avatar image

    // If no name is provided, show a fallback text
    // const displayName = localStorage.getItem('learnerName') ? localStorage.getItem('learnerName') : 'Learner';

    return (
        <div className="flex items-center space-x-4 ">
            {/* Profile Picture */}
            <div className="relative">
                <img
                    src={profilePicUrl || defaultAvatar}
                    alt="Profile"
                    className="w-12 h-12 rounded-full object-contain border-2 border-blue-500"
                />
                {/* Badge (if you want to add status like 'online', 'offline', etc.) */}
                {/* <span className="absolute bottom-1 right-2 w-4 h-4 rounded-full bg-green-400 border-2 border-white"></span> */}
            </div>

            {/* Learner Name */}
            <div className="text-lg font-semibold text-white capitalize" style={{ color: quiz || isMobile ? "#FFF" : themeStyles.text, marginRight: isMobile ? 20 : -5 }}>
                {learnerName}
            </div>
        </div>
    );
};

export default ProfilePicture;
